import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoChunksUploadComponent } from '../../components/video-chunks-upload/video-chunks-upload.component';

@NgModule({
  exports: [
    VideoChunksUploadComponent
  ],
  declarations: [
    VideoChunksUploadComponent
  ],
  imports: [
    CommonModule
  ]
})
export class VideoChunksUploadModule { }
